import { PreloaderIcon } from './icons';

interface IPreloader {
    size?: number;
    color?: string;
}

const Preloader = ({ size = 80, color = '#64748B' } : IPreloader) => {
    return (
        <div className="flex items-center justify-center my-10">
            <PreloaderIcon size={ size } color={ color } />
        </div>
    )
};

export default Preloader;